import { useEffect, useState } from "react";
import UAParser from "ua-parser-js";


export const useDeviceDetector = (): UAParser.IResult => {
    const [deviceInfo, setDeviceInfo] = useState<UAParser.IResult>({
        ua: "",
        browser: {
            name: "",
            version: "",
            major: ""
        },
        engine: {
            name: "",
            version: ""
        },
        os: {
            name: "",
            version: ""
        },
        device: {
            model: "",
            type: "",
            vendor: ""
        },
        cpu: {
            architecture: ""
        }
    });

    useEffect(() => {
        if (window.navigator.userAgent) {
            const parser = new UAParser(window.navigator.userAgent);
            const result = parser.getResult();
            setDeviceInfo(result);
        }

    }, [window.navigator.userAgent])

    return deviceInfo;
};